import React from 'react';

const FormError = (props) => {
  let jsx = null;
  if (typeof props.error === 'string' && props.error !== '') {
    jsx = <div className="form-error"><span>*</span> {props.error}</div>
  }
  return (
    <>
     {jsx}
    </>
  );
};

export default FormError;